<template>
    <div class="table">
        <!-- 头部 -->
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <!-- 表格内容 -->
        <div class="container">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="标题:">
                    <el-input v-model="queryParams.name" placeholder="请输入标题" clearable></el-input>
                </el-form-item>
                <el-form-item label="位置:">
                    <el-select v-model="queryParams.position" placeholder="请选择位置" clearable @change="changeQuery">
                        <el-option v-for="items in positionList" :key="items.index" :label="items.name" :value="items.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="平台:">
                    <el-select v-model="queryParams.platform" placeholder="请选择平台" clearable @change="changeQuery">
                        <el-option v-for="items in platformList" :key="items.index" :label="items.name" :value="items.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="关联门店:">
                    <el-select clearable v-model="queryParams.shop_id" placeholder="请选择关联门店" @change="changeQuery">
                        <el-option
                            v-for="items in shopList"
                            :key="items.shop_id"
                            :label="items.shop_name"
                            :value="items.shop_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态:">
                    <el-select v-model="queryParams.state" placeholder="请选择状态" clearable @change="changeQuery">
                        <el-option label="上线" :value="2"></el-option>
                        <el-option label="已下架" :value="3"></el-option>
                        <el-option label="下线" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <div style="float: right">
                    <el-button type="primary" @click="changeQuery()">搜索</el-button>
                </div>
            </el-form>
            <div class="action">
                <el-button type="primary" @click="add()">新增</el-button>
            </div>
            <el-table v-loading="loading" :data="pageInfo.list" element-loading-text="数据加载中" stripe border ref="multipleTable">
                <el-table-column prop="id" label="id" width="80" align="center"></el-table-column>
                <el-table-column prop="r" label="排序" width="80" align="center"></el-table-column>
                <el-table-column label="图标" align="center" width="80" prop="image">
                    <template slot-scope="scope">
                        <el-image
                            @click="showBigImg(scope.$index)"
                            style="height: 23px; width: 30px"
                            fit="cover"
                            :class="`column${scope.$index}`"
                            :src="scope.row.image"
                            :preview-src-list="[scope.row.image]"
                            ref="image"
                        >
                            <div slot="error" class="image-slot">
                                <el-image fit="cover" :src="defaultImg"></el-image>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="标题" align="center"></el-table-column>
                <el-table-column label="关联门店" prop="shop.shop_name" align="center" width="120"></el-table-column>
                <el-table-column label="跳转地址" prop="url" align="center"></el-table-column>
                <el-table-column label="位置" prop="position_name" align="center" width="120"></el-table-column>
                <el-table-column label="平台" prop="platform_name" align="center" width="120"></el-table-column>
                <el-table-column label="开始时间" prop="ctime" width="180" align="center"></el-table-column>
                <el-table-column prop="etime" label="结束时间" width="180" align="center"></el-table-column>
                <el-table-column label="状态" prop="state" align="center" width="80">
                    <template slot-scope="scope">
                        <el-tag type="info" v-if="scope.row.state === 1">下线</el-tag>
                        <el-tag type="primary" v-if="scope.row.state === 2">上线</el-tag>
                        <el-tag type="info" v-if="scope.row.state === 3">已下架</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="170" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="edit(scope.$index, scope.row)">编辑</el-button>
                        <el-button v-if="scope.row.state === 2" type="text" class="red" @click="state(scope.row, 1)">下线 </el-button>
                        <el-button v-if="scope.row.state === 1" type="text" class="green" @click="state(scope.row, 2)"> 上线</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
        </div>
        <!-- 新增 编辑 -->
        <el-dialog :title="title" :visible.sync="addVisible" width="600px" v-if="addVisible" class="dialog_box">
            <el-form ref="form" :model="form" label-width="90px" :rules="rules" label-position="left">
                <el-form-item label="排序" prop="r">
                    <el-input v-model="form.r" placeholder="数字越大越靠前" type="number"></el-input>
                </el-form-item>
                <el-form-item label="标题" prop="name">
                    <el-input v-model="form.name" placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item label="门店" prop="shop_id">
                    <el-select v-model="form.shop_id" placeholder="请选择门店" class="handle-select mr10">
                        <el-option
                            v-for="items in shopList"
                            :key="items.shop_id"
                            :label="items.shop_name"
                            :value="items.shop_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="跳转链接" prop="url">
                    <el-input v-model="form.url" placeholder="请输入跳转链接"></el-input>
                    <el-button @click.prevent="loadUrl">选择链接</el-button>
                    <br>
                    <span class="span_gray">也可以直接粘贴外部的跳转链接</span>
                </el-form-item>
                <!-- 图片上传 -->
                <el-form-item label="图片" prop="image">
                    <el-input v-model="form.image" placeholder="请输入图片链接"></el-input>
                    <el-button @click.prevent="choiceImg">选择图片</el-button>
                    <el-upload
                        class="avatar-uploader up"
                        :action="IMAGE_UPLOAD_PRO_URL"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                        name="file"
                        :headers="header"
                    >
                        <img v-if="form.image" :src="form.image" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <span class="span_gray">建议尺寸750*228像素</span>
                </el-form-item>
                <el-form-item label="位置" prop="position">
                    <el-select v-model="form.position" placeholder="请选择位置" class="handle-select mr10">
                        <el-option v-for="items in positionList" :key="items.index" :label="items.name" :value="items.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="发布平台" prop="platform">
                    <el-select v-model="form.platform" placeholder="请选择平台" :multiple="multiple" class="handle-select mr10">
                        <el-option v-for="items in platformList" :key="items.index" :label="items.name" :value="items.key"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="起止时间" prop="time">
                    <el-date-picker
                        ref="drawDate"
                        :picker-options="pickerOptions"
                        style="margin-left: 5px"
                        v-model="form.time"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="状态" prop="state">
                    <el-radio-group v-model="form.state">
                        <el-radio :label="2">上线</el-radio>
                        <el-radio :label="1">下线</el-radio>
                        <el-radio :label="3">已下架</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveData">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 上线、下线提示框 -->
        <el-dialog title="提示" :visible.sync="confirmVisible" width="300px" center>
            <div class="del-dialog-cnt">{{ confirmContent }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取 消</el-button>
                <el-button type="primary" @click="stateData">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 选择链接对话框 -->
        <div class="url">
            <Url :urlVisible="urlVisible" :shopId="form.shop_id" @toggle="toggle" @getUrl="getUrl"></Url>
        </div>
        <!-- 选择图片对话框 -->
        <div class="img">
            <Picture :ImgVisible="ImgVisible" @toggleImg="toggleImg" @getImg="getImg"></Picture>
        </div>
    </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/Pagination';
import loadEvents from '@/utils/loading';
import Url from '@/components/Url';
import Picture from '@/components/Picture';
import { request } from '@/common/request';
import { deal } from '@/common/main';
import { IMAGE_UPLOAD_PRO_URL } from '../../common/const';
let loads = new loadEvents();
export default {
    name: 'seller',
    components: {
        Breadcrumb,
        Pagination,
        Url,
        Picture
    },
    data() {
        return {
            IMAGE_UPLOAD_PRO_URL: IMAGE_UPLOAD_PRO_URL,
            defaultImg: require('../../assets/img/zhan.jpeg'),
            multiple: false,
            ImgVisible: false,
            urlList: {},
            urlVisible: false,
            header: {},
            menuList: ['店铺', '广告'],
            queryParams: {
                ty: 1,
                ctime: '',
                etime: '',
                searchName: '',
                page: 1,
                pagesize: 10
            },
            //验证规则
            rules: {
                r: [
                    {
                        required: true,
                        message: '序号不能为空',
                        trigger: 'blur'
                    }
                ],
                name: [
                    {
                        required: true,
                        message: '标题不能为空',
                        trigger: 'blur'
                    }
                ],
                platform: [
                    {
                        required: true,
                        message: '平台不能为空',
                        trigger: 'blur'
                    }
                ],
                image: [
                    {
                        required: true,
                        message: '图片不能为空',
                        trigger: 'blur'
                    },
                    { validator: deal.checkImage, trigger: ['blur', 'change'] }
                ],
                url: [{ validator: deal.checkUrl, trigger: ['blur', 'change'] }],
                time: [
                    {
                        required: true,
                        message: '起止时间不能为空',
                        trigger: 'blur'
                    }
                ],
                state: [
                    {
                        required: true,
                        message: '状态不能为空',
                        trigger: 'blur'
                    }
                ],
                position: [
                    {
                        required: true,
                        message: '位置不能为空',
                        trigger: 'blur'
                    }
                ]
            },
            positionList: [],
            brandList: [
                {
                    user: '安正',
                    id: '1'
                }
            ],
            platformList: [],
            loading: false,
            pageInfo: {},
            addVisible: false,
            confirmVisible: false,
            confirmContent: '',
            title: '加载中',
            mode: 'add',
            form: {
                state: 2,
                shop_id: null,
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            shopList: [] // 门店列表
        };
    },
    watch:{
        'form.shop_id': {
            handler(newVal, oldVal) {
                console.log(  {newVal,oldVal, types: typeof  oldVal})
                // 当 shop_id 发生变化时，清除 url
                if (oldVal !== newVal && typeof  oldVal ==='string') {
                    this.form.url = '';
                }
            }
        }
    },
    created() {
        this.header.token = localStorage.getItem('token');
        this.header.platform = 'admin';
        deal.getconf('ad', this);
        if (this.platformList) {
            this.loadData();
        }

        this.getShopList();
    },

    //图片上传
    methods: {
        //跳转链接
        loadUrl() {
            console.log(this.form)
            if (!this.form.hasOwnProperty('shop_id') ||  this.form.shop_id===null){
                this.$message.error('请先选择门店');
                return
            }
            this.urlVisible = true;
        },
        // 门店列表
        getShopList() {
            this.loading = true;
            request.get('/account/merchant/hotfan/shopList', { page: 1, pageNum: 99999 }).then((ret) => {
                if (ret.code == 1) {
                    this.shopList = ret.data.list;
                    // 在门店列表 push默认的门店到 索引 0
                    this.shopList.unshift({shop_name:"默认",shop_id:""})
                }
            });
        },
        toggle(val) {
            if (!this.form ||  this.form.shop_id === null){
                this.$message.error('请先选择门店');
            }
            // 关闭 url对话框
            this.urlVisible = val;
        },
        getUrl(url) {
            // 获取选择的URL
            this.form.url = url;
        },
        toggleImg(val) {
            // 关闭 img对话框
            this.ImgVisible = val;
        },
        choiceImg() {
            this.ImgVisible = true;
        },
        getImg(url) {
            // 获取选择的img
            this.$set(this.form, 'image', url);
        },
        //获取平台
        statestam(row) {
            return deal.platformFormat(row.platform);
        },
        //图片上传
        handleAvatarSuccess(res, file) {
            if (res.code == 1) {
                loads.close();
                this.$set(this.form, 'image', res.data.uri);
            }
        },
        // 查看大图
        showBigImg(index) {
            this.$nextTick(function () {
                let shows = document.getElementsByClassName(`column${index}`);
                let show = shows[0].getElementsByClassName('el-image-viewer__wrapper');
                show[0].style['display'] = 'block';
                let dom = show[0].getElementsByClassName('el-image-viewer__mask');
                dom[0].addEventListener('click', function () {
                    show[0].style['display'] = 'none';
                });
            });
        },
        beforeAvatarUpload(file) {
            loads.open('.avatar-uploader .el-upload', '上传中');
            const _this = this;
            return deal.imageFormat(file, _this, 300);
        },
        //广告列表
        loadData() {
            this.loading = true;
            let _this = this;
            request.get('/common/ad/list', this.queryParams).then((ret) => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.pageInfo.list = ret.data.list;
                    this.pageInfo.list.map(function (val) {
                        val.ctime = deal.timestamp(val.ctime, 'unix');
                        val.etime = deal.timestamp(val.etime, 'unix');
                        if (_this.platformList) {
                            _this.platformList.map((item) => {
                                if (item.key === val.platform) {
                                    _this.$set(val, 'platform_name', item.name);
                                }
                            });
                        }
                        return val;
                    });
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //分页
        changeQuery() {
            this.queryParams.page = 1;
            this.loadData();
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val;
            this.loadData();
        },
        refreshPageNum(val) {
            this.queryParams.page = val;
            this.loadData();
        },
        //新增
        add() {
            this.mode = 'add';
            this.title = '新增广告';
            this.form = {
                state: 2,
                url: ''
            };
            this.multiple = true;
            this.addVisible = true;
            if (this.$refs.form) {
                this.$refs.form.clearValidate();
            }
        },
        //编辑
        edit(index, row) {
            this.mode = 'edit';
            this.title = '编辑广告';
            this.multiple = false;
            this.current = row.id;
            const item = this.pageInfo.list[index];
            let time = [item.ctime, item.etime];
            //处理时间
            this.form = Object.assign({}, item);
            this.$set(this.form, 'time', time);
            console.log(1111111, this.form);
            this.addVisible = true;
        },
        //状态
        state(row, state) {
            if (state == 2) {
                this.confirmContent = '确定是否上线?';
            } else {
                this.confirmContent = '确定是否下线?';
            }
            this.form = Object.assign({}, row);
            this.form.state = state;
            this.form.ctime = deal.timestamp(this.form.ctime);
            this.form.etime = deal.timestamp(this.form.etime);
            this.confirmVisible = true;
        },
        //增加编辑
        saveData() {
            if (this.$refs.form) {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        var url = this.mode == 'add' ? '/common/ad/add' : '/common/ad/edit';
                        this.form.ctime = deal.timestamp(this.form.time[0]);
                        this.form.etime = deal.timestamp(this.form.time[1]);
                        if (this.mode === 'add') {
                            let platform = this.form.platform.join(',');
                            this.form.platform = platform;
                        }
                        //处理时间
                        request.post(url, this.form).then((ret) => {
                            if (ret.code == 1) {
                                this.addVisible = false;
                                this.loadData();
                                this.$message.success((this.mode == 'add' ? '新增' : '编辑') + '成功');
                                this.$refs.form.clearValidate();
                            } else {
                                this.$message.error(ret.msg);
                            }
                        });
                    } else {
                        this.$message.error('请补全信息');
                        return false;
                    }
                });
            }
        },
        // 确定下线
        stateData() {
            request.post('/common/ad/edit', this.form).then((ret) => {
                if (ret.code == 1) {
                    this.$message.success('操作成功');
                    this.loadData();
                    this.confirmVisible = false;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.red {
    color: #ff0000;
}

.green {
    color: green;
}

.span_gray {
    font-size: 12px;
    color: gray;
}

.dialog_box >>> .el-dialog__body {
    padding: 20px 30px 20px 60px;
}

.dialog_box >>> .el-dialog__header {
    padding: 30px 30px 10px;
}

.dialog_box .el-form-item--small.el-form-item {
    margin-bottom: 20px;
}

.dialog_box .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.dialog_box .avatar {
    font-size: 28px;
    width: 250px;
    height: 72px;
    line-height: 200px;
}

.dialog_box .up {
    margin-top: 10px;
    margin-bottom: -10px;
}

.dialog_box .el-button {
    margin-left: 20px;
}
</style>
